/* Author : Nitish Hardeniya */
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Login from '../components/loginNew';
import * as authActions from '../actions/authActions';

function mapStateToProps(state) {
  return {
    auth: state.auth,
    userLoginData: state.auth.userLoginData || {},
    countryCodes: state.LoginReducer.countryCodes,
    encryptionKey: state.LoginReducer.encryptionKey,
    profiles: state.LoginReducer.profiles,
    OTPSent: state.LoginReducer.OTPSent,
    errorString: state.LoginReducer.errorString,
    tempToken: state.LoginReducer.tempToken,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...authActions,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
